import React from "react";

const ProductCard = ({ title, value, icon }) => {
  return (
    <div className="product-card">
      <div className="product-card-content">
        <h3 className="product-card-title">{title}</h3>
        <div className="product-card-value">{value}</div>
      </div>
      <div className={`product-card-icon`}>
        <img src={icon} alt={title} className="" />
      </div>
    </div>
  );
};

export default ProductCard;
